import { Injectable } from '@angular/core';
import posthog from 'posthog-js';

// SD-1137: Thin wrapper around posthog-js so feature code doesn't import posthog directly.
// Keeps event names in one place, swallows SDK errors (analytics should never crash the app).
@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  capture(event: string, properties?: Record<string, any>): void {
    try {
      posthog.capture(event, properties || {});
    } catch (err) {
      console.warn('PostHog capture failed:', err);
    }
  }

  identify(distinctId: string, properties?: Record<string, any>): void {
    try {
      posthog.identify(distinctId, properties || {});
    } catch (err) {
      console.warn('PostHog identify failed:', err);
    }
  }

  reset(): void {
    try {
      posthog.reset();
    } catch (err) {
      // noop
    }
  }
}
